import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <>
        <footer className="footer_section">
    <div className="container">
      <div className="row">
        <div className="col-md-4 footer-col">
          <div className="footer_contact">
            <h4>
              Contact Us
            </h4>
            <div className="contact_link_box">
              <Link to=''>
                <i className="fa fa-map-marker" aria-hidden="true"></i>
                <span>
                  Location
                </span>
              </Link>
              <Link to='tel:+1-1234567890'>
                <i className="fa fa-phone" aria-hidden="true"></i>
                <span>
                  +01 1234567890
                </span>
              </Link>
              <Link to='mailto:demo@gmail.com'>
                <i className="fa fa-envelope" aria-hidden="true"></i>
                <span>
                  demo@gmail.com
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className="col-md-4 footer-col">
          <div className="footer_detail">
            <Link to='' className="footer-logo">
              Feane
            </Link>
            <p>
              Necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with
            </p>
            <div className="footer_social">
              <Link to='https://www.facebook.com' target='_blank'>
                <i className="fa fa-facebook" aria-hidden="true"></i>
              </Link>
              <Link to='https://www.twitter.com' target='_blank'>
                <i className="fa fa-twitter" aria-hidden="true"></i>
              </Link>
              <Link to='https://www.linkedin.com' target='_blank'>
                <i className="fa fa-linkedin" aria-hidden="true"></i>
              </Link>
              <Link to='https://www.instagram.com' target='_blank'>
                <i className="fa fa-instagram" aria-hidden="true"></i>
              </Link>
              <Link to='https://www.pinterest.com' target='_blank'>
                <i className="fa fa-pinterest" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>
        <div className="col-md-4 footer-col">
          <h4>
            Opening Hours
          </h4>
          <p>
            Everyday
          </p>
          <p>
            10.00 Am -10.00 Pm
          </p>
        </div>
      </div>
      <div className="footer-info">
        <p>
          &copy; <span id="displayYear"></span> All Rights Reserved.  
          <Link to="https://www.haidersoftwares.com" target='_blank'><img src='./assets/images/Haider-Softwares-Logo.png' style={{height:'40px'}}/></Link>
         
        </p>
      </div>
    </div>
  </footer>
        </>
    )
}

export default Footer;